/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2025-12-31 10:14:36
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2026-01-26 19:26:59
 * @FilePath: /knit-web/src/store/modules/app/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { defineStore } from 'pinia';
import type { RouteRecordNormalized } from 'vue-router';
import defaultSettings from '@/config/settings.json';
import { AppState } from './types';

const useAppStore = defineStore('app', {
  state: (): AppState => ({
    ...defaultSettings,
    profileModalVisible: defaultSettings.profileModalVisible ?? false,
    profileDefaultTab:
      (defaultSettings.profileDefaultTab as 'members' | 'resources') ??
      'members',
    accountModalVisible: false,
  }),

  getters: {
    appCurrentSetting(state: AppState): AppState {
      return { ...state };
    },
    appDevice(state: AppState) {
      return state.device;
    },
    appAsyncMenus(state: AppState): RouteRecordNormalized[] {
      return state.serverMenu as unknown as RouteRecordNormalized[];
    },
  },

  actions: {
    // Update app settings
    updateSettings(partial: Partial<AppState>) {
      // @ts-ignore-next-line
      this.$patch(partial);
    },

    // Change theme color
    toggleTheme(dark: boolean) {
      if (dark) {
        this.theme = 'dark';
        document.body.setAttribute('arco-theme', 'dark');
      } else {
        this.theme = 'light';
        document.body.removeAttribute('arco-theme');
      }
    },
    toggleDevice(device: string) {
      this.device = device;
    },
    toggleMenu(value: boolean) {
      this.hideMenu = value;
    },
    clearServerMenu() {
      this.serverMenu = [];
    },
    // 打开个人中心弹窗
    openProfileModal(tab?: 'members' | 'resources') {
      this.profileModalVisible = true;
      if (tab) {
        this.profileDefaultTab = tab;
      }
    },
    // 关闭个人中心弹窗
    closeProfileModal() {
      this.profileModalVisible = false;
    },
    // 设置个人中心默认标签
    setProfileDefaultTab(tab: 'members' | 'resources') {
      this.profileDefaultTab = tab;
    },
    // 打开 Account 弹窗
    openAccountModal() {
      this.accountModalVisible = true;
    },
    // 关闭 Account 弹窗
    closeAccountModal() {
      this.accountModalVisible = false;
    },
  },
});

export default useAppStore;
